import { useSyncExternalStore } from 'react'
import type { GameRuntime } from '../game/runtime'

export function useRuntimeState(runtime: GameRuntime) {
  return useSyncExternalStore(runtime.subscribe, runtime.getState, runtime.getState)
}
